import React from "react";
import { useMainStore } from "../store";

export const DateOfBirthSelector = () => {
  const onDateOfBirthChange = (e) => {
    useMainStore.setState({ dateOfBirth: e.target.value });
    localStorage.setItem("dob", e.target.value);
  };

  return (
    <div
      style={{
        display: "flex",
        // width: "100%",
        justifyContent: "center",
        marginBottom: "12px",
      }}
    >
      <label style={{ marginRight: "4px" }}>Date of birth:</label>
      <input
        type="date"
        max={new Date().toISOString().split("T")[0]}
        defaultValue={localStorage.getItem("dob")}
        onChange={(e) => onDateOfBirthChange(e)}
      />
    </div>
  );
};
